import { Button, ButtonProps } from 'antd';
import { LmsLinkItemKey } from '../../constants/types/lms/type';
import { useLmsGuideLink } from '../../hooks/lms/useLmsGuideLink';

interface LmsGuideButtonProps extends Omit<ButtonProps, 'onClick' | 'type'> {
  itemKey: LmsLinkItemKey;
}

/** LMS 각 페이지 헤더의 '이용 안내' 버튼 공통 컴포넌트 */
const LmsGuideButton = ({
  itemKey,
  className,
  children = '이용 안내',
  ...rest
}: LmsGuideButtonProps) => {
  const { link, openGuide } = useLmsGuideLink(itemKey);

  // 링크가 없으면 버튼 자체를 노출하지 않음
  if (!link) return null;

  return (
    <Button
      type="primary"
      className={`shrink-0 rounded-lg !border-purple5 !bg-purple5 px-4 hover:!border-purple6 hover:!bg-purple6 ${
        className ?? ''
      }`}
      onClick={openGuide}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default LmsGuideButton;
